import { Component } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { AuthService } from './core/auth/auth.service';
import { HttpClientModule } from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [NgClass, RouterOutlet, ResponsiveHelperComponent, HttpClientModule],
})
export class AppComponent {
  title = 'VAS Aviation';

  constructor(public themeService: ThemeService) {}
}
